<template>
  <div v-if="store.form.currentStep === 'stepFour' || store.debug">
    <Steps class="mt-4 mt-md-0" @finishStepEmit="finishStepEmit"/>

    <hr class="d-md-none ml-4 mr-4">
    <div class="pl-4 pl-lg-0">
      <div class="row mt-3">
        <div class="col-12 col-md-6 pr-5 pr-md-0">
          <h6 class="text-uppercase text-muted font-weight-bold text-14">{{
              t('personalForm.headers.kontaktniUdaje')
            }}</h6>
          <table class="table table-borderless table-sm mb-1">
            <tr>
              <td style="width: 40%">{{ t('personalForm.firstName') }}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ this.store.order.contactInfo.firstName }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{{ t('personalForm.surName') }}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ this.store.order.contactInfo.surName }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{{ t('personalForm.email') }}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ this.store.order.contactInfo.email }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{{ t('personalForm.phone') }}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ store.getFormattedPhoneNumber() }}
                </strong>
              </td>
            </tr>
          </table>
          <div class="mt-3">
            <span class="h6 text-uppercase font-weight-bold text-muted text-14">{{ t('personalForm.poznamka') }}</span>
            <p style="font-size: 15px">
              <strong>
                {{ this.store.order.contactInfo.poznamka }}
              </strong>
            </p>
          </div>

        </div>


        <div class="col-12 col-md-6 pr-5 pr-md-4">
          <h6 class="text-uppercase text-muted font-weight-bold text-14">{{
              t('personalForm.headers.fakturacniUdaje')
            }}</h6>
          <table class="table table-borderless table-sm mb-1">
            <tr v-if="store.form.mamIco === 'mam'">
              <td style="width: 40%">{{ t('personalForm.ico') }}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ this.store.order.contactInfo.address.invoiceAddress.ico }}
                </strong>
              </td>
            </tr>
            <tr v-if="store.form.mamIco === 'mam'">
              <td style="width: 40%">{{ t('personalForm.dic') }}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ this.store.order.contactInfo.address.invoiceAddress.dic }}
                </strong>
              </td>
            </tr>
            <tr>
              <td style="width: 40%" v-if="store.form.osoba === 'pravnicka' && lang === 'cs'">{{ t('personalForm.name') }}:</td>
              <td style="width: 40%" v-else-if="lang === 'cs'">{{ t('personalForm.firstName') }} a <span
                  class="text-lowercase">{{ t('personalForm.surName') }}</span>:
              </td>
              <td style="width: 40%" v-else-if="store.form.osoba === 'pravnicka'">
                {{ t('personalForm.companyName') }}:
              </td>
              <td style="width: 40%" v-else>
                {{ t('personalForm.name') }}:
              </td>
              <td class="text-right text-md-left">
                <strong>
                  {{ this.store.order.contactInfo.address.invoiceAddress.companyName }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{{ t('personalForm.street') }}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ this.store.order.contactInfo.address.invoiceAddress.street }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{{ t('personalForm.city') }}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ this.store.order.contactInfo.address.invoiceAddress.city }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{{ t('personalForm.psc') }}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ this.store.order.contactInfo.address.invoiceAddress.psc }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{{ t('personalForm.country') }}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ t('personalForm.countries.' + this.store.order.contactInfo.address.invoiceAddress.country.value) }}
                </strong>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <hr>

      <div class="row mt-3">
        <div class="col-12 col-md-6">
          <h6 class="text-uppercase text-muted font-weight-bold text-14">{{
              t('personalForm.headers.objednaneSluzby')
            }}</h6>

          <table class="table table-borderless table-sm mb-1">
            <tr :class="{'d-flex flex-column' : lang === 'en'}">
              <td class="text-nowrap pr-3">{{ t('personalForm.virtualSeatFor') }}:</td>
              <td class="font-weight-bold">{{ this.store.order.contactInfo.address.companyAddress.companyName }}</td>
            </tr>
            <tr :class="{'d-flex flex-column' : lang === 'en'}">
              <td>{{ t('personalForm.seatAddress') }}:</td>
              <td class="font-weight-bold">{{ t('sidla.' + this.store.getSeatProduct()[0].codeForTran) }}</td>
            </tr>
            <tr :class="{'d-flex flex-column' : lang === 'en'}">
              <td>{{ t('personalForm.period') }}:</td>
              <td class="font-weight-bold">{{ t('years.m' + this.store.getSeatProduct()[0].months) }}</td>
            </tr>
            <tr v-if="store.form.mamIco === 'mam'" :class="{'d-flex flex-column' : lang === 'en'}">
              <td class="pr-3" :class="{'text-nowrap' : lang === 'cs'}">{{ t('personalForm.zmenaSidla') }}:</td>
              <td class="font-weight-bold">
                {{ store.form.vyrizeniZmenySidla ? t('sendOrder.values.true') : t('sendOrder.values.false') }}
              </td>
            </tr>
            <tr :class="{'d-flex flex-column' : lang === 'en'}">
              <td>{{ t('payment.paymentType') }}:</td>
              <td class="font-weight-bold">
                <span v-if="this.store.order.paymentType === 'payment.card'">
                  {{ t('payment.card') }}
                </span>
                <span v-else>{{ t('payment.bank') }}</span>
              </td>
            </tr>
          </table>

          <span></span>
          <p class="font-weight-bold"></p>
          <span></span>
          <p class="font-weight-bold"></p>
          <span></span>
          <p class="font-weight-bold"></p>
          <span></span>
          <p class="font-weight-bold"></p>
          <p class="font-weight-bold"></p>
        </div>
        <div class="col-12 col-md-6">
          <div class="mb-4 mr-3">
            <div class="priceWrapper p-3" style="background-color: #f5f8fc">
              <div class="jakeFormCustomLabel mb-2" data-v-0f2e8fdc="">{{ t('souhrnCeny') }}:</div>
              <TotalPriceOfProducts/>
              <hr>
              <TotalPrice/>
            </div>
          </div>

          <div class="ml-auto mt-4 mb-4  mr-4 mr-md-3 text-left" style="font-size: 14px">
            <div class="custom-control custom-checkbox">
              <input class="custom-control-input"
                     :class="{'is-invalid': isBlurred() && !store.order.checkTermsAndConditions}"
                     v-model="store.order.checkTermsAndConditions" type="checkbox" value=""
                     id="checkAgreement">
              <label class="custom-control-label" for="checkAgreement">
                {{ t('agreement.agreementS') }}
                <a :href="t('agreement.termsUrl')" class="text-primary" target="_blank">
                  {{ t('agreement.obchodniPodminky') }}</a>
              </label>
              <div v-if="isBlurred() && !store.order.checkTermsAndConditions" class="invalid-feedback">
                {{ t('personalForm.required.termsAndConditions') }}
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="text-right pb-4 pr-4">
        <div v-if="orderError" class="small font-weight-bold error-block text-danger mb-2 text-center text-md-right" role="alert">
          {{ t('submitError') }}
        </div>

        <div class="row d-md-none">
          <div class="col-3 col-md text-left text-md-right ">
            <button class="btn btn-sm btn-primary mr-0 px-2" type="button" @click='previousStep'>
              {{ t('buttons.zpet') }}
            </button>

          </div>
          <div class="col pr-1">
            <button v-if="store.order.paymentType=== 'payment.card'"
                    class="btn btn-sm btn-secondary text-right px-3" type="button" @click="sendOrder">
              <span v-html="sendingSpinner"/>
              {{ t('buttons.odeslatObjednavku') }}
              {{ t('buttons.aZaplatit') }}
            </button>
            <button v-if="store.order.paymentType=== 'payment.bank'" class="btn btn-sm btn-secondary px-3" type="button"
                    @click="sendOrder"><span v-html="sendingSpinner"/>
              {{ t('buttons.odeslatObjednavku') }}
            </button>

          </div>
          <div class="col-12 text-center px-0">
            <hr>
            <NeedHelp/>
          </div>
        </div>
        <div class="d-none d-md-flex text-left pb-4 pr-5 pr-md-4">
          <div class="mr-auto col-5">
            <need-help/>
          </div>
          <div>
            <button v-if="!this.store.form.formSucceed" class="btn btn-primary mr-3 px-4 ml-auto"
                    type="button"
                    @click='previousStep'>{{ t('buttons.zpet') }}
            </button>
            <button v-if="store.order.paymentType=== 'payment.card'"
                    class="btn btn-secondary text-right px-4" type="button"
                    @click="sendOrder"><span v-html="sendingSpinner"/>
              {{ t('buttons.odeslatObjednavku') }} {{ t('buttons.aZaplatit') }}
            </button>
            <button v-if="store.order.paymentType=== 'payment.bank'" class="btn btn-secondary px-4" type="button"
                    @click="sendOrder"><span v-html="sendingSpinner"/> {{ t('buttons.odeslatObjednavku') }}
            </button>
          </div>
        </div>


      </div>

    </div>
  </div>
</template>

<script>
import {useI18n} from "vue-i18n";
import {ref} from 'vue'
import {store} from "../store.js";
import TotalPrice from "../others/TotalPrice.vue";
import TotalPriceOfProducts from "../others/TotalPriceOfProducts.vue";
import Steps from "../others/StepsComponent/Steps.vue";
import NeedHelp from "@/components/others/NeedHelp.vue";
import {useProductName} from "@/composables/useProductName";
import * as Sentry from "@sentry/vue";

export default {
  name: "StepFour",
  components: {NeedHelp, Steps, TotalPriceOfProducts, TotalPrice},
  props: ['currentStep'],

  setup() {
    const {t, locale} = useI18n({useScope: 'global'})
    const {orderItemName} = useProductName()
    const lang = locale;
    const select = ref(0)
    return {t, select, lang, orderItemName}
  },
  data() {
    return {
      errors: [],
      store,
      orderError: false,
    }
  },
  methods: {
    isBlurred() {
      return this.store.form.steps.stepFour.blurred;
    },
    previousStep() {
      // console.log('back step');
      //this.store.form.currentStep = 'stepTwo';
      this.store.goToStep('stepThree');

    },
    prepareProducts() {
      var prodArray = [];
      this.store.order.products.forEach((item) => {

        var amount = 1;
        if (item.totalPriceWithVat)
          var totalPriceWithVat = item.totalPriceWithVat
        if (item.totalPriceWithoutVat)
          var totalPriceWithoutVat = item.totalPriceWithoutVat

        if(!item.totalPriceWithoutVat && !item.totalPriceWithVat && item.standardPrice){
          item.totalPriceWithVat = item.standardPrice * store.getVatForProduct(item);
          item.totalPriceWithoutVat = item.standardPrice;
        }

        if (item.type === 'seat') {
          amount = item.months;
          totalPriceWithVat = item.totalPriceWithVat / amount;
          totalPriceWithoutVat = item.totalPriceWithoutVat / amount;
        }

        var arItem = {
          "name": this.orderItemName(item),
          "code": item.code,
          "amount": amount,
          "priceWithVat": String((Math.round(totalPriceWithVat*100)/100)),
          "priceWithoutVat": String((Math.round(totalPriceWithoutVat*100)/100)),
          "vatRate": item.vatRateId,
          "amountUnit": item.unit,
          "jakeIsId": item.id
        };
        prodArray.push(arItem);

      });
      // console.log(prodArray);
      return prodArray;
    },
    prepareAddresses() {
      var o = this.store.order;
      var arrayAdd = [];

      var invoiceAdd = {
        "companyName": o.contactInfo.address.invoiceAddress.companyName,
        "firstName": o.contactInfo.firstName,
        "lastName": o.contactInfo.surName,
        "street": o.contactInfo.address.invoiceAddress.street,
        "city": o.contactInfo.address.invoiceAddress.city,
        "country": o.contactInfo.address.invoiceAddress.country.code,
        "postCode": o.contactInfo.address.invoiceAddress.psc,
        "ico": o.contactInfo.address.invoiceAddress.ico,
        "dic": o.contactInfo.address.invoiceAddress.dic,
        "addressType": "invoice",
      }

      //subjekt ketrý bude na adrese sídlit.
      var companyAddress = {
        "companyName": o.contactInfo.address.companyAddress.companyName,
        "firstName": o.contactInfo.firstName,
        "lastName": o.contactInfo.surName,
        "street": o.contactInfo.address.companyAddress.street,
        "city": o.contactInfo.address.companyAddress.city,
        "country": o.contactInfo.address.companyAddress.country.code,
        "postCode": o.contactInfo.address.companyAddress.psc,
        "ico": o.contactInfo.address.companyAddress.ico,
        "dic": o.contactInfo.address.companyAddress.dic,
        "addressType": "primary",
      }
      console.log(invoiceAdd);
      arrayAdd.push(invoiceAdd)
      arrayAdd.push(companyAddress)
      return arrayAdd;
    },
    checkStep() {
      if (!this.store.order.checkTermsAndConditions) {
        this.store.form.steps.stepFour.blurred = true;
        return false;
      }
      return true
    },
    sendOrder() {
      // hlavni odesilac
      if (!this.checkStep()) return;

      if (!this.store.form.formSending) {

        this.store.form.formSending = true;
        this.orderError = false;
        try {
          this.store.gaEventFinishForm();
        } catch (e) {
          console.error(e);
        }

        // console.log('Odesílám do strapi');
        // console.log('Odesílám do swiss');
        this.postOrder();
      }
      //console.log(order);
      /* if (order) {
         console.log('Odesílám do Raynetu');
         //this.sendLead(order);
       }*/
    },

    prepareData() {
      var o = this.store.order;
      var payment = '';
      var canSendToIs = false;
      if (o.paymentType === 'payment.card') {
        payment = 'CARD';
      } else {
        payment = 'BANK';
        canSendToIs = true;
      }
      var data = {
        "orderType": "seat",
        "email": o.contactInfo.email,
        "phone": store.getFormattedPhoneNumber(),
        "sourceUrl": window.location.href,
        "sourceWeb": window.location.host,
        "successCallbackUrl": window.location.protocol + '//' + window.location.host + '/thankyou/seat-payment-success',
        "errorCallbackUrl": window.location.protocol + '//' + window.location.host + '/thankyou/seat-payment-error',
        "currency": this.store.form.currency,
        "items": this.prepareProducts(),
        "paymentType": payment,
        "addresses": this.prepareAddresses(),
        "lang": this.store.form.language,
        "totalPriceWithVat": String(this.store.calcOrderTotalPriceWithVat()),
        "totalPriceWithoutVat": String(this.store.calcOrderTotalPriceNoVat()),
        "orderNote": this.prepareOrderNote(),
        "note": o.contactInfo.poznamka,
        "raynetLeadId": o.raynetLeadId,
        "canSendIS": canSendToIs,
        "additionalFields": this.prepareAdditionalFields(),
      }
      // console.log(data)
      return data;

    },
    finishLeadOrder(orderId) {
      var o = this.store.order;

      //var url = 'http://192.168.0.109:800/raynet/send-lead';
      // webhook
      var url = this.store.urls.jakeSwissUrl + '/raynet/finish-lead-order/' + orderId;
      //  var url = 'https://eofi6lvf9rwiigm.m.pipedream.net';
      return this.axios.get(url).then((response) => {
        if (response.status === 200) {
          // console.log('Odesláno do swiss/raynet')
          // console.log(response.data)
          return true;
        } else {
          // console.log(response)
          // console.log(response.data);
          return false;
        }
      }).catch((error) => {
        console.error('Chyba dokončení leadu', error);
        return false;
      })
    },

    postOrder() {
      var o = this.store.order;

      //var url = 'https://eofi6lvf9rwiigm.m.pipedream.net';
      // var url = this.store.urls.strapiUrl;
      var url = this.store.urls.jakeSwissUrl + "/api/order/create";
      //var url = 'https://seal-app-2bvf4.ondigitalocean.app/api/orders';

      // var strapiPost = this.axios.post(url,
      //     {
      //       "data": this.prepareData()
      //     }
      // )

      // console.log(JSON.stringify({"attributes": this.prepareData()}));

      let data;
      try {
        data = this.prepareData();
      } catch (error) {
        this.errorOrder(error);
        return;
      }

      this.axios.post(url, {
        "attributes": data
      }).then((response) => {
        if (response.status === 201) {
          this.store.form.formSucceed = true;
          // odeslani lead do jake-swiss
          // console.log(response.data)
          this.finishLeadOrder(response.data.uuid);
          this.store.order.uuid = response.data.uuid;
          // console.log(this.store.createGaEventFinishOrderData());
          this.store.seatClarityEvent('finish-order');
          this.store.vueClarityEvent('finish-order');
          if (this.store.order.paymentType === 'payment.bank') {
            this.store.gaEventFinishOrder();
            this.finishOrder()
          } else if (this.store.order.paymentType === 'payment.card') {
            let orderGuid = response.data.uuid;
             console.log('Order UUID: ' + orderGuid);
            const gatewayUrl = this.store.urls.jakeSwissUrl + '/payment/gateway/' + orderGuid + '?do=webPayButton-checkout';
            try {
              window.top.location.href = gatewayUrl;
            } catch (e) {
              window.location.href = gatewayUrl;
            }
          }
        } else {
          this.errorOrder(new Error('Neočekávaný status ' + response.status));
        }
      }, (error) => {
        // jen chyba requestu, výjimka v success větvi nesmí ukázat chybu u vytvořené objednávky
        this.errorOrder(error);
      })
    },
    errorOrder(error) {
      console.error('Chyba odeslání objednávky', error);
      // výpadek sítě (bez response) do Sentry neposílat, každá chyba spouští replay a free plán jich má 50/měsíc
      if (!error?.isAxiosError || error.response) {
        Sentry.withScope((scope) => {
          scope.setTag('order-submit', 'true');
          Sentry.captureException(error);
        });
      }
      this.orderError = true;
      this.store.form.formSending = false;
    },

    thankYouPage() {

    },
    finishOrder() {
      this.store.form.formSending = false;
      this.store.form.steps.stepFour.visited = true;
      this.store.form.steps.stepFour.filled = true;
      this.store.form.currentStep = 'stepFive';
      this.store.scrollTop();


    },
    prepareAdditionalFields(){
      return {
        osoba: this.store.form.osoba,
        mamIco: this.store.form.mamIco,
        vyrizeniZmenySidla: this.store.form.vyrizeniZmenySidla,
      }
    },
    prepareOrderNote() {
      // podrobnosti objednávky pro lead
      var o = this.store.order;
      var oNote = '<b>Souhrn:</b> <br>';

      oNote += `Klient si objednal virtuální sídlo pro <b>${store.form.osoba === 'pravnicka' ? 'právnickou' : 'fyzickou'}</b> osobu`;

      if (store.form.mamIco === 'mam')
        oNote += ` (IČO <b>${o.contactInfo.address.companyAddress.ico}</b>).<br><br>`
      else
        oNote += " (ještě nemá IČO).<br><br>";


      // namapování produktů pro další výpis bez produktu sídla
      let seat;
      let otherProducts = [];
      o.products.forEach(product => {
        if (product.type === 'seat')
          seat = product;
        else
          otherProducts.push(product);
      })

      // pokud mám ičo
      if (store.form.mamIco === 'mam') {
        oNote += `<b>Vybraná adresa:</b> ${seat.name} ${seat.totalPriceWithoutVatFilter} bez DPH <br>`;
        oNote += `<b>Vyřízení změny v rejstříku:</b> ${store.form.vyrizeniZmenySidla ? 'ano' : 'ne'}<br>`;

        // pokud je vyřízení změny sídla a jedná se o právnickou osobu vypsat dané možnosti
        if (store.form.vyrizeniZmenySidla && store.form.osoba === 'pravnicka') {

          // aktuální sídlo je
          oNote += `<b>Aktuální sídlo je:</b> `;
          if(store.form.sidloVeSmlouve === 'konkretniAdresa')
            oNote += 'konkrétní adresa <br>';
          else if(store.form.sidloVeSmlouve === 'obec')
            oNote += 'obec <br>'
          else if(store.form.sidloVeSmlouve === 'nevim')
            oNote += 'nevím, poraďte mi <br>'

          // pokud je zvolená obec tak vypsat zvolenou možnost
          if (store.form.sidloVeSmlouve === 'obec')
            oNote += `<b>Nová adresa sídla je:</b> ${store.form.adresaSidlaJe === 'stejnaObec' ? 've stejné obci' : 'v jiné obci'}<br>`;

          //pokud je zvoleno konkrétní adresa nebo obec tak vypsat položky změny sídla
          if (store.form.sidloVeSmlouve !== 'nevim') {
            oNote += '<b>Položky změny sídla:</b> <br>';
            otherProducts.forEach(element => {
              oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + element.totalPriceWithoutVatFilter + ' bez DPH<br>';
            })
          }
        } else if(store.form.vyrizeniZmenySidla && store.form.osoba === 'fyzicka'){
          // pokud chce vyřízení sídla a jedná se o fyzickou osobu tak vypsat položky
          oNote += '<b>Položky změny sídla:</b> <br>';
          otherProducts.forEach(element => {
            oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + element.totalPriceWithoutVatFilter + ' bez DPH <br>';
          })
        }

        // poznámka
        oNote += `<b>Poznámka:</b> ${o.contactInfo.poznamka}<br><br>`;

        //fakturace pro
        if (store.form.sameInvoiceAddressOwnSeat)
          oNote += `Klient chce fakturovat na ${store.form.osoba === 'pravnicka' ? 'firmu' : 'OSVČ'}, pro kterou objednává sídlo<br>`;
        else if (o.contactInfo.address.invoiceAddress.ico)
          oNote += `Klient chce fakturovat na toto IČO: ${o.contactInfo.address.invoiceAddress.ico}<br>`;


      } else { // pokud nemám ičo
        oNote += `<b>Vybraná adresa:</b> ${seat.name} ${seat.totalPriceWithoutVatFilter} bez DPH <br>`;
        if (store.form.osoba === 'pravnicka')
          oNote += `<b>Plánovaný název firmy:</b> ${o.contactInfo.address.companyAddress.companyName}<br>`;
        else
          oNote += `<b>Jméno a příjmení budoucí OSVČ:</b> ${o.contactInfo.address.companyAddress.companyName}<br>`;
        oNote += `<b>Poznámka:</b> ${o.contactInfo.poznamka}<br><br>`;

        oNote += `Klient chce fakturovat na nově vznikající ${store.form.osoba === 'pravnicka' ? 'firmu' : 'OSVČ'}, pro kterou objednal sídlo.`

      }
      // oNote += `<b>Sídlo pro:</b> ${store.form.osoba}<br>`;
      // oNote += `<b>OSVČ/firma již existuje: </b>${store.form.mamIco === 'mam' ? 'ano' : 'ne'}<br>`;
      // if (store.form.mamIco !== 'mam')
      //   oNote += `<b>Plánovaný název firmy/Jméno a příjmení OSVČ:</b> ${store.order.contactInfo.address.companyAddress.companyName}</br>`;
      // oNote += `<b>Poznámka:</b> ${store.order.contactInfo.poznamka}</br>`;
      // //pokud mám ico
      // if (this.store.form.mamIco === 'mam') {
      //   // přidat změnu sídla
      //   oNote += '<b>' + this.t('sendOrder.zmenaSidla') + ': ' + '</b>' + this.t('sendOrder.values.' + this.store.form.vyrizeniZmenySidla) + '<br>';
      //   //pokud je pravnicka osoba a chce změnu sídla
      //   if (this.store.form.osoba === 'pravnicka' && this.store.form.vyrizeniZmenySidla) {
      //     // aktuální sídlo ve smlouvě je
      //     oNote += '<b>' + this.t('personalForm.headers.sidloVeSmlouve') + ': ' + '</b>'
      //         + (this.store.form.sidloVeSmlouve === 'nevim'
      //             ? this.t('personalForm.radioButtons.nevim') //nevím
      //             : this.store.form.sidloVeSmlouve === 'obec' ? 'Obec' //obec
      //                 : this.t('personalForm.radioButtons.konkretniAdresa')) //konkrétní adresa
      //         + '<br>';
      //     // pokud je zvolená obec
      //     if (this.store.form.sidloVeSmlouve === 'obec') {
      //       // připsat nová adresa je stejná | jiná obec.
      //       oNote += '<b>' + this.t('personalForm.headers.novaAdresaJe')
      //           + ': ' + '</b>'
      //           + (this.store.form.adresaSidlaJe === 'stejnaObec'
      //               ? 've stejné obci' : 'v jiné obci')
      //           + '<br>';
      //     }
      //   }
      // }
      //
      // oNote += '<br> Produkty: <br>'
      // o.products.forEach(element => {
      //   if (element.type === 'seat') oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + element.totalPriceWithoutVat + ' Kč bez DPH <br>'
      //   else oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + element.standardPrice + ' Kč bez DPH <br>'
      // });

      return oNote;
    },
  },
  watch: {
    'store.form.currentStep'() {
      this.orderError = false;
    },
  },
  computed: {
    getSelectedTradeTypes() {
      return this.store.order.products.filter(obj => {
        return obj.type === 'tradeType'
      });
    },
    getSeatProduct() {
      return this.store.getSeatProduct();
    },
    phoneWithSpaces() {
      return this.store.order.contactInfo.phone.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    sendingSpinner() {
      if (this.store.form.formSending) {
        return '<img width="20" style="margin-left:-10px; margin-right: 5px;" src="/assets/jake-style/imgs/loading/loading.svg"/> ';
      } else return '';
    },
    clearSeatCode(code) {
      if (code.includes('_')) console.log('obsahuje:' + code);
    }
  },
  created() {


  },

}
</script>

<style lang="scss" scoped>
.table {
  font-size: 15px;

}
</style>